import { render } from "./LifeProviderSelection.vue?vue&type=template&id=7fb120ea&scoped=true"
import script from "./LifeProviderSelection.vue?vue&type=script&lang=js"
export * from "./LifeProviderSelection.vue?vue&type=script&lang=js"

import "./LifeProviderSelection.vue?vue&type=style&index=0&id=7fb120ea&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fb120ea"]])

export default __exports__